import { get, post } from '@/services/axios'
import { axiosOptions } from '@/constant/axios'

class AcademicAffairs {
    //教务数据导入-列表
    getEducationalData() {
        
        return post('/TsManageApi/educationalAdminList',{})
    }
    //院系管理-获取院系树列表
    getAuthTreeList() {
        
        return post('/AuthManageApi/authTreeList',{})
    }
    //院系管理-院系树排序
    setTreeSortord(params: { departid: string}) {
        
        return post('/DepartmentApi/dragSort',params)
    }

    //变更机构名称
    editSchooleName(params: { name: string}) {
        
        return post('/DepartmentApi/collegeRename',params)
    }
    //新建节点
    createDepartment(params: { pid: string,departname: string}) {
        
        return post('/TsManageApi/addDepartment',params)
    }
    //编辑节点
    updateDepartment(params: { id: string,departname: string}) {
        
        return post('/TsManageApi/updateDepartment',params)
    }
    //获取是否可以删除状态
    getDelTip(params: { id: string}) {
        
        return post('/TsManageApi/delTipsDepartment',params)
    }
    //删除节点数据
    removeDepartment(params: { id: string}) {
        
        return post('/TsManageApi/delDepartment',params)
    }
    //转移节点数据
    transferNode(params: { departid: string,objDepartid:string}) {
        
        return post('/DepartmentApi/transferDepartment',params)
    }


    //行政班级列表
    getAdminClassList(params: any) {
        
        return post('/ClassApi/getAdminClassList',params)
    }
    //行政班级del
    adminClassDelete(params: any) {
        
        return post('/ClassApi/adminClassDelete',params)
    }
    //行政班级detail
    getAdminClassDetailList(params: any) {
        return post('/ClassApi/studentList',params)
    }
    //从行政班里面删除学生
    delStudentFromAgencyClass(params: any) {
        return post('/ClassApi/delStudentFromAgencyClass',params)
    }
    //老师列表
    getTeacherList(params: any) {
        return post('/TsManageApi/getTeacherList',params)
    }
    //老师列表-获取开放师生身份认证
    getApproveState() {
        return post('/TsManageApi/getApproveState',{})
    }
    //老师列表-设置开放师生身份认证
    approveStateSwitch(params:any) {
        return post('/TsManageApi/approveStateSwitch',params)
    }
     //老师列表-单个添加
     addAgencyTeacher(params:any) {
        return post('/TsManageApi/addAgencyTeacher',params)
    }
     //老师列表-单个编辑
     editMechanismTeacher(params:any) {
        return post('/TsManageApi/editMechanismTeacher',params)
    }
     //老师列表、学生列表-删除
     userDelete(params:any) {
        return post('/TsManageApi/userDelete',params)
    }
    //老师列表-取消认证
    dismissUserAgency(params:any) {
        return post('/TsManageApi/dismissUserAgency',params)
    }
    //老师列表-详情
    getTeacherInfo(params:any) {
        return post('/TsManageApi/getTeacherInfo',params)
    }
    //老师列表-详情-数据列表
    getTeacherTypeAnalysis(params:any) {
        return post('/TsManageApi/getTeacherTypeAnalysis',params)
    }
    //学生列表
    getStudentList(params:any) {
        return post('/TsManageApi/getStudentList',params)
    }
    //学生列表-单个添加
    addAgencyStudent(params:any) {
        return post('/TsManageApi/addAgencyStudent',params)
    }
    //学生列表-编辑
    editMechanismStudent(params:any) {
        return post('/TsManageApi/editMechanismStudent',params)
    }
    //学生列表-详情
    getStudentInfo(params:any) {
        return post('/TsManageApi/getStudentInfo',params)
    }
    //学生列表-详情列表
    studentJoinClass(params:any) {
        return post('/TsManageApi/studentJoinClass',params)
    }

    //学生列表-详情-作业-list
    stuInfoWorkList(params:any) {
        return post('/TsManageApi/stuInfoWorkList',params)
    }
    //学生列表-详情-作业-chart
    stuInfoWorkChart(params:any) {
        return post('/TsManageApi/stuInfoWorkChart',params)
    }
    //学生列表-详情-考勤-list
    stuInfoAttenceList(params:any) {
        return post('/TsManageApi/stuInfoAttenceList',params)
    }
     //学生列表-详情-考勤-chart
     stuInfoAttenceChart(params:any) {
        return post('/TsManageApi/stuInfoAttenceChart',params)
    }
    //学生列表-详情-测试-list
    stuInfoTestList(params:any) {
        return post('/TsManageApi/stuInfoTestList',params)
    }
     //学生列表-详情-测试-chart
     stuInfoTestChart(params:any) {
        return post('/TsManageApi/stuInfoTestChart',params)
    }
    //学生列表-详情-课堂互动-chart
    stuInfoInteractiveChart(params:any) {
        return post('/TsManageApi/stuInfoInteractiveChart',params)
    }
     //学生列表-详情-课堂互动-list
     stuInfoInteractiveList(params:any) {
        return post('/TsManageApi/stuInfoInteractiveList',params)
    }
    //学生列表-详情-课堂交流-chart
    stuInfoChatChart(params:any) {
        return post('/TsManageApi/stuInfoChatChart',params)
    }
     //学生列表-详情-资料-list
     stuInfoDataList(params:any) {
        return post('/TsManageApi/stuInfoDataList',params)
    }
    //学生列表-详情-资料-chart
    stuInfoChart(params:any) {
        return post('/TsManageApi/stuInfoChart',params)
    }
     //学生列表-详情-表现-list
     stuInfoDisplayList(params:any) {
        return post('/TsManageApi/stuInfoDisplayList',params)
    }
    //学生列表-详情-表现-chart
    stuInfoDisplayChart(params:any) {
        return post('/TsManageApi/stuInfoDisplayChart',params)
    }
    //课程认证-获取开启状态
    getApproveStateClass() {
        return post('/ClassApi/getApproveState',{})
    }
    //课程认证-开启切换
    approveStateSwitchClass(params: { state: string,starttime?: string,endtime?: string,departmentid?: string,semester?: string,term?: string}) {
        return post('/ClassApi/approveStateSwitch',params)
    }
    //机构课程-自动创建关联 课堂派课程
    setTeachClassAutoCreate(params: { departmentid: string,semester: string,term: string}) {
        return post('/ClassApi/teachClassAutoCreate',params)
    }
    //批量删除
    batchRemove(params: { teachClassId: string,forceDelete:number}) {
        return post('/ClassApi/deleteTeachClass',params)
    }
    //取消绑定课程
    setUnbind(params: { teachclassid: string}) {
        return post('/ClassApi/cancelBindCourse',params)
    }
    //机构授课班级
    getTeachClassPage(params: { departid: string,search: string,beginTime: string,endTime: string,page: string,relation: string}) {
        return post('/ClassApi/teachClassPage',params)
    }
    //机构授课 --获取老师学生是否本机构
    getTeachUserInfo(params: { realstno: string, usertype: string}) {
        return post('/CourseApi/getUserCertificationInfo',params)
    }
    //机构授课 -- 添加课程
    addOneCourse(params: { collegeId: string,coursenum: string,teachclassnum: string,coursename: string,teacherston: string,teachername: string,teachclassname: string,coursebegin: string,term: string,studentInfo: string,}) {
        return post('/CourseApi/addOneCourse',params)
    }
    //机构授课 -- 编辑课程
    editOneCourse(params: { collegeId: string,coursenum: string,teachclassnum: string,coursename: string,teacherston: string,teachername: string,teachclassname: string,coursebegin: string,term: string, forceFeUpdate?:number}) {
        return post('/CourseApi/collegeCourseEdit',params)
    }
    //机构授课班级-获取选课学生
    getTeachClassList(params: { classid: string, search: string, atteststate: string, page: number}) {
        return post('/ClassApi/teachClasStudents',params)
    }
    //机构授课班级-删除选课学生
    removeTeachClass(params: { joinid: string}) {
        return post('/ClassApi/teachClasStudentDelete',params)
    }
    //机构授课班级-添加选课学生
    addTeachClass(params: { realname: string,realstno: string,classid: string}) {
        return post('/ClassApi/teachClasStudentAdd',params)
    }

    //向行政班添加学生
    addStudentToAgencyClassByJuid(params: { juid: string,classid: string}) {
        return post('/ClassApi/addStudentToAgencyClassByJuid',params)
    }

    //机构授课-获取课程统计详情
    getCourseDetails(params: { courseid: string}) {
        return post('/ClassApi/classSummary',params)
     }

    //课程统计-获取学生
    getCourseStudents(params: { courseid: string,page:number}) {
        return post('/ClassApi/students',params)
    }

    //课程统计-获取助教
    getCourseAssistant(params: { courseid: string, page: number }) {
        return post('/CourseApi/getAssistant', params)
    }

    //课程统计-添加助教
    addCourseAssistant(params: { courseid: string, assistantrealstno: string, type: 1 | 2 }) {
        return post('/CourseApi/addAssistant', params)
    }

    //课程统计-删除助教
    deleteManageAssistant(params: { courseid: string, assistantrealstno: string, userid?:string }) {
        return post('/CourseApi/deleteManageAssistant', params)
    }

    // 权限设置列表
    getAssistantManage(params: { courseid: string, state: string, page: number, assistantrealstno: string }) {
        return post<{
            status: number,
            partList: {
                content: any[],
                contentTotal: string,
            },
            withinCount: string,
            outside: string,
        }>('/CourseApi/getAssistantManage', params)
    }

    // 获取助教可管理分组列表
    getMyClass(params: { courseid: string, assistantrealstno: string }) {
        return post('/CourseApi/getMyClass', params)
    }

    // 选择助教管理学生范围列表
    selectStudent(params: {
        courseid: string,
        assistantrealstno: string,
        data: null | 'section' | {
            type: number,
            id: string
        }[],
    }) {
        return post('/CourseApi/selectStudent', params)
    }
    // 删除学生（助教权限范围管理的学生）
    deleteManageStudent(params: { courseid: string, id: string, assistantrealstno: string }) {
        return post('/CourseApi/deleteManageStudent', params)
    }
    //课程统计-获取资料
    getCourseData(params: { courseid: string,page:number}) {
        return post('/ClassApi/data',params)
    }
    //课程统计-获取作业
    getCourseHomeworks(params: { courseid: string,page:number}) {
        return post('/ClassApi/homeworks',params)
    }
    //课程统计-获取作业详情
    getCourseHomeworksInfo(params: { id: string}) {
        return get('/ClassApi/getHomework',params)
    }
    //课程统计-获取互动
    getCourseInteract(params: { courseid: string,page:number}) {
        return post('/ClassApi/interact',params)
    }
    //课程统计-获取测试
    getCourseTests(params: { courseid: string,page:number}) {
        return post('/ClassApi/tests',params)
    }
    //课程统计-获取测试详情
    getCourseTestsInfo(params: { id: string}) {
        return get('/ClassApi/getTest',params)
    }
    //课程统计-获取考勤
    getCourseAttence(params: { courseid: string,page:number}) {
        return post('/ClassApi/attence',params)
    }
    //课程统计-获取表现
    getCoursePerform(params: { courseid: string,page:number}) {
        return post('/ClassApi/perform',params)
    }
    //课程统计-获取公告
    getCourseAnnounces(params: { courseid: string,page:number}) {
        return post('/ClassApi/announces',params)
    }
    //课程统计-获取公告详情
    getCourseAnnouncesInfo(params: { id: string}) {
        return get('/ClassApi/getAnnounce',params)
    }

    //将课堂派的里面的课程的学生名单与选课名单强制对齐
    classForcedCheckData(params: { classid: string}){
        return post('/ClassApi/classForcedCheckData',params)
    }
    //逻辑删除选课名单数据
    delAgencyMyteachClassData(params: { id: string}){
        return post('/ClassApi/delAgencyMyteachClassData',params)
    }
    //删除某个已经加入课程的成员
    removeCourseStudent(params: { courseid: string, studentuid:string}){
        return post('/ClassApi/removeCourseStudent',params)
    }
    //生成跟这个课程关联的督导视角
    generateSupervisor(params: { courseid: string}){
        return post('/ClassApi/generateSupervisor',params)
    }
    //通过加课码进入督导
    gotoSuperviseByCode(params: { code: string},axiosoptions?:axiosOptions){
        return post('/ClassApi/gotoSuperviseByCode', params, axiosoptions)
    }

    //课程统计-添加助教
    addCourseStudent(params: { courseid: string, stno: string, type: 1 | 2 }) {
        return post('/CourseApi/addCourseStudent', params)
    }

    //清空督导视角
    clearSupervisorCache(params: {},axiosoptions?:axiosOptions){
        return post('/ClassApi/clearSupervisorCache', params, axiosoptions)
    }

    //重置密码
    resetpassword(params: { juid: string, password: string},axiosoptions?:axiosOptions){
        return post('/TsManageApi/resetpassword', params, axiosoptions)
    }
    
    //转让课程
    transforCourse(params: { relationId: string, teacherNo: string},axiosoptions?:axiosOptions){
        return post('/ClassApi/transforCourse', params, axiosoptions)
    }

    //获取选课数据的总数
    getStudentSelectionCount(params: { coursebegin: string, term: number},axiosoptions?:axiosOptions){
        return post('/TsManageApi/getStudentSelectionCount', params, axiosoptions)
    }
}

const academicAffairsApi = new AcademicAffairs()
export default academicAffairsApi
